import React from 'react';
import { soup } from "../utils/menu_soup";
import { starterVeg, starterNonVeg } from "../utils/menu_starter";
import {
  clayOven,
  riceNoodles,
  vegMainCourse,
  chickenMainCourse,
  muttonMainCourse,
  seafoodMainCourse,
  varietyRiceMainCourse,
} from "../utils/menu_main";
import { biryaniVeg, biryaniNonVeg } from "../utils/menu_biriyani";
import {
  vegDosa,
  nonVegDosa,
  uthappam,
  southIndianDelicacies,
} from "../utils/menu_dosa";
import { cholabreadCorner } from "../utils/menu_cholaspecial";
import { drinks, desserts } from "../utils/menu_drinkdessert";

const TITLE_COLOR = '#000000'; // Color for titles and key text

// CholaMenu Component
const CholaMenu = () => (
  <div style={{ fontFamily: 'Arial, sans-serif', margin: '20px', lineHeight: '1.6' }}>
    <h1 style={{ textAlign: 'center', color: TITLE_COLOR }}>CHOLA CAFE MENU</h1>

    {/* Soups Section */}
    <Section title="SOUPS">
      {soup.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Vegetarian Starters Section */}
    <Section title="STARTERS (VEGETARIAN)">
      {starterVeg.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Non-Vegetarian Starters Section */}
    <Section title="STARTERS (NON-VEGETARIAN)">
      {starterNonVeg.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* From the Clay Oven Section */}
    <Section title="FROM THE CLAY OVEN">
      {clayOven.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Rice and Noodles Section */}
    <Section title="Rice / Noodles">
      {riceNoodles.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Vegetarians Main Course Section */}
    <Title title="VEGETARIANS MAIN COURSE"></Title>
    <Section title="( SERVED WITH RICE )">
      {vegMainCourse.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Chicken Main Course Section */}
    <Title title="CHICKEN MAIN COURSE"></Title>
    <Section title="( SERVED WITH RICE )">
      {chickenMainCourse.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Mutton Main Course Section */}
    <Section title="MUTTON MAIN COURSE">
      {muttonMainCourse.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Sea Food and Egg Section */}
    <Section title="SEA FOOD AND EGG">
      {seafoodMainCourse.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Rice Corner Section */}
    <Title title="RICE CORNER"></Title>
    <Section title="BIRYANI (VEG)">
      {biryaniVeg.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    <Section title="BIRYANI (NON-VEG)">
      {biryaniNonVeg.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>


    <Title title="VARIETY RICE"></Title>
    <Section title="( SERVED WITH PICKLE, VADA AND PAPAD )">
      {varietyRiceMainCourse.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    <Title title="DOSA CORNER"></Title>
    <Section title="VEG - DOSA  (ADD TOPPINGS FOR $1 EACH – TOMATO, PODI, CHEESE, ONION, POTATO MASALA, GHEE)">
      {vegDosa.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    <Title title="NON-VEG DOSA"></Title>
    <Section title="( SERVED WITH CHICKEN CURRY OR SAMBAR AND CHUTNEY )">
      {nonVegDosa.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
      {uthappam.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    <Section title="SOUTH INDIAN DELICACIES">
      {southIndianDelicacies.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    <Section title="Chola’s Special Bread Corner">
      {cholabreadCorner.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Desserts Section */}
    <Section title="DESSERTS">
      {desserts.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>

    {/* Drinks Section */}
    <Section title="Drinks">
      {drinks.map((item, index) => (
        <MenuItem key={index} name={item.foodName} price={`$${item.price}`} description={item.description} />
      ))}
    </Section>
    <Section> </Section>
    <Section title="Note : Menu some items price may have changed"></Section>


  </div>
);

// Section Component

const Section = ({ title, children }) => (
  <div style={{ margin: '30px 0' }}>
    <h2 style={{ textAlign: 'center', color: TITLE_COLOR }}>{title}</h2>
    <hr
      style={{
        border: 'none',
        height: '2px',
        backgroundColor: TITLE_COLOR,
        marginTop: '20px',
      }}
    />
    {children}
  </div>
);

const Title = ({ title, children }) => (
  <div style={{ margin: '30px 0' }}>
    <h2 style={{ textAlign: 'center', color: TITLE_COLOR }}>{title}</h2>
    {children}
  </div>
);

// MenuItem Component
const MenuItem = ({ name, price, description }) => (
  <div style={{ margin: '15px 0' }}>
    <span
      style={{
        fontWeight: 'bold',
        fontSize: '1.1em',
        marginLeft: '0px',
        color: TITLE_COLOR,
      }}
    >
      {name}
    </span>
    <span
      style={{
        float: 'right', // Price aligned to the right
        fontWeight: 'bold',
        marginRight: '0px',
        color: TITLE_COLOR,
      }}
    >
      {price}
    </span>
    <p style={{ marginLeft: '', marginRight: '100px', color: TITLE_COLOR }}>{description}</p>
  </div>
);

export default CholaMenu;
